import { render, staticRenderFns } from "./CarInfo.vue?vue&type=template&id=563582f0&scoped=true&"
import script from "./CarInfo.vue?vue&type=script&lang=js&"
export * from "./CarInfo.vue?vue&type=script&lang=js&"
import style0 from "./CarInfo.vue?vue&type=style&index=0&id=563582f0&lang=less&scoped=true&"
import style1 from "./CarInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563582f0",
  null
  
)

export default component.exports